import {
  Box,
  Button,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import { ReactComponent as GiftBanner } from "../../../assets/images/gift-banner.svg";
import { ReactComponent as GiftIcon } from "../../../assets/icons/gift-colored.svg";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check-outlined-colored.svg";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { removeNonNumeric } from "../../../utils/Utils";
import { CancelOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useRequest } from "../../../api/utils/useRequest";
import { BalootUserV2APIs } from "../../../api/APIs";
import { useSnackBar } from "../../../context/SnackBarContext";

const cacheltr = createCache({
  key: "muiltr",
  stylisPlugins: [],
});

function ProfileGiftPage() {
  const navigate = useNavigate();
  const openSnack = useSnackBar();
  const [successCode, setSuccessCode] = useState(false);
  const [code, setCode] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const { loading, apiCall: sendCode } = useRequest(BalootUserV2APIs.voucher);

  const handleClick = () => {
    sendCode({
      data: { code },
      onSuccess: () => {
        setSuccessCode(true);
      },
      onError: (error) => {
        if (error.status === 400) {
          setErrorMsg(error.message);
        } else {
          openSnack(true, { message: error.message });
        }
      },
    });
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            ثبت کارت هدیه
          </Typography>
        }
      />
      <Box
        sx={{
          overflow: "auto",
          flex: 1,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "100%", minHeight: 300 }}></Box>
        <PageContentContainer
          sx={{
            display: "block",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Box
            sx={{
              mt: -35,
              minHeight: 450,
              bgcolor: "common.white",
              width: "100%",
              px: "16px",
              py: "16px",
              borderRadius: "12px",
              boxShadow: (theme) => theme.shadows[3],
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <GiftBanner width={270} height={275} />
            </Box>
            {successCode ? (
              <>
                <Box sx={{ display: "flex", alignItems: "center", mt: 5 }}>
                  <CheckIcon width={20} height={22} />
                  <Typography ml={1} variant="h4" color="grey.2">
                    شماره کارت هدیه با موفقیت ثبت شد
                  </Typography>
                </Box>
                <Typography mt={2} variant="body2" color="grey.3">
                  این هدیه از طرف بلوط بوده و شما می‌توانید از این مبلغ برای
                  سرمایه‌گذاری استفاده کنید
                </Typography>
              </>
            ) : (
              <>
                <Typography
                  mt={3}
                  variant="body2"
                  color="grey.2"
                  align="center"
                >
                  شماره سریال کارت هدیه را وارد کنید
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", mt: 5 }}>
                  <GiftIcon width={24} height={24} />
                  <Typography ml={1} variant="h4" color="grey.2">
                    شماره سریال
                  </Typography>
                </Box>
                {/* <CacheProvider value={cacheltr}> */}
                <TextField
                  error={Boolean(errorMsg)}
                  helperText={errorMsg}
                  inputProps={{
                    inputMode: "numeric",
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          {code.length > 0 && (
                            <IconButton
                              onClick={() => {
                                setErrorMsg("");
                                setCode("");
                              }}
                            >
                              <CancelOutlined sx={{ fontSize: 20 }} />
                            </IconButton>
                          )}
                        </Box>
                      </InputAdornment>
                    ),
                  }}
                  value={code}
                  onChange={(event) => {
                    setErrorMsg("");
                    if (event.target.value === null) {
                      setCode("");
                    } else {
                      event.target.value.length < 17 &&
                        setCode(removeNonNumeric(event.target.value));
                    }
                  }}
                  sx={{ mt: "12px", direction: "ltr" }}
                  fullWidth
                />
                {/* </CacheProvider> */}
                <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                  <LoadingButton
                    onClick={handleClick}
                    loading={loading}
                    disabled={code.length < 16}
                    variant="contained"
                    sx={{ color: "common.white", typography: "h5", width: 94 }}
                    size="small"
                  >
                    تایید
                  </LoadingButton>
                </Box>
              </>
            )}
          </Box>
        </PageContentContainer>
      </Box>
    </>
  );
}

export default ProfileGiftPage;
